import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SelectLocation from "../dropdown";
import { Link } from "react-router-dom";
import axios from "../../API/axios";

Banner07.propTypes = {};


function Banner07(props) {

  //  const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [userList, setUserList] = useState([]);
    const [searchuserList, setSearchuserList] = useState([]);
    const [searchUserName, setSearchUserName] = useState("");
  
    const [isError, setIsError] = useState(false); 
    const [nextBatchLoading, setNextBatchLoading] = useState("");
  

    const getAllUserList = (page) => {
      setNextBatchLoading(true);
      const data = {
        pageNumber: page,
        pageSize: 20,
      };
    
      axios
        .post(`/Candidate/GetAll?Search=${searchUserName}`, data)
        .then((response) => {
          const res = response.data.responseData.candidateProfiles; 
          setUserList(res);
          setIsLoading(false);
          setTotalPages(response.data.responseData.paging.totalPages);
    
          const newPosts = response.data.responseData.candidateProfiles;
          console.log("newwwwposttt", newPosts);
    
          if (searchUserName !== "") {
            setUserList([]);
            setSearchuserList(newPosts);
          } else {
            setSearchuserList([]);
            setUserList((prev) => {
              const userSet = new Set(prev?.map((user) => user?.uid));
              const uniqueNewPosts = newPosts.filter(
                (user) => !userSet.has(user?.uid)
              );
              return [...prev, ...uniqueNewPosts];
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            setIsError(true);
          } else {
            console.log(error);
          }
          setIsLoading(false);
          setNextBatchLoading(false);
        });
    };
    
     useEffect(() => {
        if (page <= totalPages) {
          getAllUserList(page + 1);
        }
    
        if (searchUserName) {
          setUserList([]);
          getAllUserList(1, searchUserName);
        }  
      }, [page, searchUserName]);
    
    
  return (
    <section className="tf-slider sl5  ">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="content">
              <div className="heading text-center">
                <h2>Find Candidate </h2>
                <p>
                  Resume-Library is a true performance-based job board. Enjoy
                  custom hiring products and access to up to 10,000 new resume
                  registrations daily, with no subscriptions or user licences.
                </p>
              </div>
            
              <div className="form-sl">
                <form action="">
                  <div className="row-group-search home1 st">
                    <div className="form-group-1">
                      <span className="icon-search search-job "></span>
                      <input
                        type="text"
                        className="input-filter-search"
                        id="exampleInputEmail1"
                        placeholder="Search candidate"
                        onChange={(e) => {
                          setSearchUserName(e.target.value);
                          getAllUserList();
                        }}
                        value={searchUserName}
                      /> 
                    </div>
                    <div className="form-group-2">
                      <span className="icon-map-pin"></span>
                      <SelectLocation />
                    </div>
                    <div className="form-group-4">
                      <button type="submit" className="btn khojPrimaryBtn" style={{ width:'150px', height:'50px' , display:"flex"}}>
                        <Link to={`/Candidates`}>
                        Find Candidates
                        </Link>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner07;
